import * as React from "react";

function IconBottomCornerFoldedDoc(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" {...props}>
      <g
        clipPath="url(#prefix__clip0_11_19459)"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          d="M6.499 4.98v29.04A1.98 1.98 0 008.479 36h16.17l9.9-9.9V4.98A1.98 1.98 0 0032.569 3H8.479a1.98 1.98 0 00-1.98 1.98z"
          fill="#E5E9EE"
        />
        <path
          d="M26.63 26.1h7.92l-9.9 9.9v-7.92a1.98 1.98 0 011.98-1.98z"
          fill="#C0C7D1"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_11_19459">
          <path fill="#fff" d="M0 0h40v40H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconBottomCornerFoldedDoc = React.memo(IconBottomCornerFoldedDoc);
export default MemoIconBottomCornerFoldedDoc;
